import {inject, Injectable} from '@angular/core';
import {environment} from '@environments/environment.prod';
import {map, Observable} from 'rxjs';
import {
  ListDocumentTypesUseCasePort
} from '@features/setting/application/use_cases/list-document-types/list-document-types.use-case.port';
import {
  ListDocumentTypesPayloadDto
} from '@features/setting/application/use_cases/list-document-types/dto/list-document-types.payload.dto';
import {
  ListDocumentTypesResponseDto
} from '@features/setting/application/use_cases/list-document-types/dto/list-document-types.response.dto';
import {ClientHttpPort} from '@shared/application/ports/http/client.http.port';
import {LocalStoragePort} from '@shared/application/ports/storage/local.storage.port';
import {NavigationPort} from '@shared/application/ports/navigation/navigation.port';
import {
  ListDocumentTypesHttpPayloadDto
} from '@features/setting/infrastructure/http/list-document-types/list-document-types.http.payload.dto';
import {
  ListDocumentTypesHttpResponseDto
} from '@features/setting/infrastructure/http/list-document-types/list-document-types.http.response.dto';
import {
  ListDocumentTypesHttpMapper
} from '@features/setting/infrastructure/http/list-document-types/list-document-types.http.mapper';
import {FilterInterface} from '@core/interfaces/filter/filter.interface';
import {HttpHeaders} from '@angular/common/http';

@Injectable()
export class ListDocumentTypesHttpAdapter implements ListDocumentTypesUseCasePort {

  private readonly url = environment.uri;
  private readonly http = inject(ClientHttpPort);
  private readonly localStoragePort = inject(LocalStoragePort);
  private readonly navigationPort = inject(NavigationPort);

  public execute(payload: ListDocumentTypesPayloadDto): Observable<ListDocumentTypesResponseDto> {
    const url = window.location.href;
    const {suffix} = this.navigationPort.extractQueryParams(url);
    let suffixDatabase: string | null = null;
    if (!suffix) {
      suffixDatabase = this.localStoragePort.getByKey<string | null>('_suffix');
      if (!suffixDatabase) throw new Error(`Could not find suffix`);
    } else {
      suffixDatabase = suffix;
    }
    const filter: FilterInterface = {};
    const headers: HttpHeaders = new HttpHeaders({
      "token": environment.secret_key,
      "x-filter-model": JSON.stringify(filter),
    });
    return this.http.get<ListDocumentTypesHttpResponseDto>(`${this.url}document-type-list?suffix_database=${suffixDatabase}`, {headers})
      .pipe(
        map(ListDocumentTypesHttpMapper.toResponse)
      )
  }

}
